import { FC, HTMLAttributes } from "react";
import { classes, style } from "typestyle";
import { ReactComponent as checkIcon } from "../../../assets/graphics/symbols/checkmark.svg";
import { Button } from "../../elements/button.element";
import { VideoPlayer } from "../../elements/video-player/video-player.element";
import { dictionary } from "../../../state/common/constants/dictionary.constants";

export interface IProps {
  attributes?: HTMLAttributes<HTMLDivElement>;
  url: string;
  resolve: (watched: boolean) => void;
}

export const ProfessionalIntroVideoModal: FC<IProps> = (props) => (
  <div
    {...{
      ...props.attributes,
      className: classes(styles.container, props.attributes?.className),
    }}
  >
    <h2 className={styles.header}>{dictionary.literals.introduction}</h2>

    <VideoPlayer url={props.url} />

    <Button
      flavour="primary"
      icon={checkIcon}
      attributes={{ onClick: () => props.resolve(true) }}
    >
      <div className={styles.buttonText}>{dictionary.literals.finish}</div>
    </Button>
  </div>
);

const styles = {
  container: style({
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  }),
  header: style({
    color: "rgb(var(--rgb-color-primair-basis))",
    textAlign: "center",
    margin: "5px 0",
  }),
  buttonText: style({
    fontSize: "0.95rem",
  }),
};
